import { DidUser } from '@/services/auth';
import { useFlag } from '@/services/featureFlags';
import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import { PlanGroup } from '@d-id/types';

export function useRemoveWatermarkAccess(user?: DidUser | null) {
    const logoRemovalEnabled = useFlag('logo_removal_enabled', false);
    const { userSettings } = useUserSettings();
    const removeWatermarkSelected = userSettings?.preferences?.removeWatermark;

    const showRemoveWatermark = !!(
        user &&
        logoRemovalEnabled &&
        [PlanGroup.TRIAL, PlanGroup.LITE, PlanGroup.PRO, PlanGroup.ADVANCED].includes(user?.planGroup!)
    );

    const removeWatermarkBlocked = [PlanGroup.TRIAL, PlanGroup.LITE].includes(user?.planGroup!);

    return {
        showRemoveWatermark,
        removeWatermarkBlocked,
        removeWatermarkSelected: removeWatermarkSelected && showRemoveWatermark && !removeWatermarkBlocked,
    };
}
